import { legacyLodashMapper, PhoneNumberWorkflowData } from '@data/api/mappers/workflowData/toPhoneNumberData'
import { toWorkflowData } from '@data/schemas/workflowData'
import registrationUserSchema from '@data/schemas/registrationUser'
import { logSchemaValidationError } from '@data/schemas/util/logSchemaValidationError'
import { isRecord } from '@util/isRecord'
import { mixed, MixedSchema } from 'yup'

const schema: MixedSchema<PhoneNumberWorkflowData> = mixed<PhoneNumberWorkflowData>()
    .defined()
    .transform((_currentValue: unknown, originalValue: unknown) => {
        if (!isRecord(originalValue)) {
            return undefined
        }

        const embeddedUser = isRecord(originalValue._embedded) ? originalValue._embedded.user : undefined

        return {
            phoneNumber: originalValue.phoneNumber,
            workflow: toWorkflowData(originalValue),
            workflowType: 'phone-number',
            user: embeddedUser ? registrationUserSchema.validateSync(embeddedUser) : undefined,
        }
    })

export default schema

export const toPhoneNumberData = (data: unknown): PhoneNumberWorkflowData => {
    try {
        return schema.validateSync(data)
    } catch (e) {
        logSchemaValidationError(`PhoneNumberWorkflowData`, e, data)
        return legacyLodashMapper(data)
    }
}
